import React from 'react'
import './EventButton.scss'
import clsx from 'clsx'
import PlaySvg from 'assets/svg/PlaySvg'
import { followUser } from 'api'
import { getEventUrl } from 'utils'
import { useHistory } from 'react-router'
import { AUTH_MODAL_STATE } from 'store/constants'
import { requireAuth } from 'store/utils/awaitStore'
import { followUserStore } from 'store/actions'
import { useDispatch } from 'react-redux'

const EventButtonFreePurchaseable = ({ className, event, refreshEvent }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const host = event.get('host')

  const _onClick = async (e) => {
    e.stopPropagation()
    e.preventDefault()
    if (event.get('userType') === 'follower') {
      redirectToEvent()
    } else {
      await signupAndFollow()
    }
  }

  const signupAndFollow = async () => {
    if (await requireAuth(AUTH_MODAL_STATE.SIGNUP, true)) {
      await followUser({ userId: host.get('id') })
      dispatch(followUserStore(host))
      redirectToEvent()
    }
  }

  const redirectToEvent = () => {
    if (getEventUrl(event) === window.location.pathname) {
      refreshEvent && refreshEvent()
    } else {
      history.replace(getEventUrl(event))
    }
  }

  return (
    <button className={clsx('button', className)} onClick={_onClick}>
      <PlaySvg className="attend-button-icon" /> Play full video
    </button>
  )
}

export default EventButtonFreePurchaseable
